// removed by extract-text-webpack-plugin
module.exports = {"LoadingIndicator":"PuaOD2xpY7MO_d98OMs6h","rotate":"_3XuhlX2A8hGKlRvgZKQsZg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingIndicator/LoadingIndicator.scss
// module id = 2642
// module chunks = 0